<template>
  <el-dialog
    top="0px"
    width="1100px"
    title="订单供应点同步"
    class="dialogWrapper"
    :visible.sync="_dialogVisible"
    :close-on-click-modal="false"
  >
    <hx-table-result>
      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ tableData.length }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" v-loading="tableLoading" :data="tableData" max-height="800" border>
        <icTableColumnIndex :pageIndex="1" :pageSize="999999" />

        <el-table-column prop="orderNo" align="center" label="订单编号" />
        <el-table-column prop="buyerMobile" align="center" label="用户电话" />
        <el-table-column prop="orderAmount" align="center" label="订单总额" />
        <el-table-column prop="supplyDate" align="center" label="领货日期" />
        <el-table-column prop="logisticsSiteName" align="center" label="旧供应点" />
        <el-table-column prop="newSiteName" align="center" label="新供应点" />
        <el-table-column prop="supplyLevelName" align="center" label="保障级别" />
        <el-table-column prop="orderStatus" align="center" label="订单状态">
          <template slot-scope="scope">{{ orderStatusMap[scope.row.orderStatus] }}</template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleUpdate(scope.row)">更新供应点</el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </el-dialog>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  watch: {
    dialogVisible: {
      immediate: true,
      handler(value) {
        if (value && this.dialogData) {
          this.listParams = Object.assign({}, this.dialogData);
          this.loadTableData();
        }
      }
    }
  },

  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(value) {
        this.$emit("update:dialogVisible", value);
      }
    }
  },

  data() {
    return {
      listParams: {
        newLogisticSiteId: "",
        accountId: ""
      },
      tableLoading: false,
      tableData: [],
      orderStatusMap: {
        0: "已取消",
        1: "待付款",
        2: "待发货",
        3: "待收货",
        4: "待补差",
        5: "待退款",
        6: "退款中",
        7: "已完成",
        8: "交易关闭"
      }
    };
  },

  methods: {
    /**
     * 加载列表数据
     */
    async loadTableData() {
      const params = Object.assign({}, this.listParams);
      try {
        const url = global.apiUrl + "/order/getUnCompleteOrder";
        const response = await Vue.ajaxGet(this, url, params, "tableLoading");
        this.tableData = response || [];
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 更新
     * @param {*} data
     */
    async handleUpdate(data) {
      const params = { orderId: data.orderId, newLogisticSiteId: data.newLogisticSiteId };
      try {
        const url = global.apiUrl + "/order/updateOrderSite";
        await Vue.ajaxPut(this, url, params, "tableLoading");
        this.$message.success("更新成功");
        this.loadTableData();
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 关闭
     */
    handleClose() {
      this._dialogVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.dialogWrapper {
  :deep(.el-dialog__body) {
    padding: 0px 20px 20px;
  }
}
</style>
